module.exports = __webpack_public_path__ + "img/icon_shift.cf2d677a.svg";